import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconDivideM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 7.91184C2 7.42453 2.39504 7.02948 2.88235 7.02948H13.1176C13.605 7.02948 14 7.42453 14 7.91184C14 8.39915 13.605 8.79419 13.1176 8.79419H2.88235C2.39504 8.79419 2 8.39915 2 7.91184ZM8 5.61772C8.7797 5.61772 9.41177 4.98565 9.41177 4.20595C9.41177 3.42626 8.7797 2.79419 8 2.79419C7.2203 2.79419 6.58824 3.42626 6.58824 4.20595C6.58824 4.98565 7.2203 5.61772 8 5.61772ZM9.41177 11.7942C9.41177 12.5739 8.7797 13.206 8 13.206C7.2203 13.206 6.58824 12.5739 6.58824 11.7942C6.58824 11.0145 7.2203 10.3824 8 10.3824C8.7797 10.3824 9.41177 11.0145 9.41177 11.7942Z" />
  </svg>
)

export const IconDivide = createIcon({
  name: 'IconDivide',
  l: IconDivideM,
  m: IconDivideM,
  s: IconDivideM,
  xs: IconDivideM,
})
